import { render, staticRenderFns } from "./KasBesarPiutangForm.vue?vue&type=template&id=5f50ab8d"
import script from "./KasBesarPiutangForm.vue?vue&type=script&lang=js"
export * from "./KasBesarPiutangForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports